import * as angular from "angular";
import {IPromise} from 'angular';
import {AccountRequests} from './account-requests.service';
import {SplitService} from '../../commons/services/split-service.service';
import {ServiceType} from '../../deliveries/types/service.type';
import {ConfirmDialogService} from '../../commons/services/confirm-dialog.service';

export class AgentRankingDialogService {

  /* @ngInject */
  constructor(
    private $mdDialog,
    private confirmDialogService: ConfirmDialogService,
    private $filter
  ) {
  }

  /**
   * Opens the Add Agent dialog
   */
  showAddAgentDialog(event: Event, accountId: string, currentAgents: any[] = [], isRestricted?: boolean) {
    const self = this;
    return this.$mdDialog.show({
      templateUrl: 'app/modules/account/views/dialogs/add-agent-dialog.html',
      parent: angular.element(document.querySelector('#popupContainer')),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: false,
      controller: function ($scope) {
        // Initialize scope properties
        $scope.isRestricted = isRestricted;
        $scope.selectedAgentId = undefined;
        $scope.selectedAgentError = false;
        $scope.priority = 1;
        $scope.serviceType = ServiceType.Operation; // Default to Delivery
        $scope.isSubmitting = false;
        $scope.excludeIds = currentAgents.map(agent => agent.agentId).filter(id => !!id);
        $scope.serviceTypeOptions = [
          {value: ServiceType.Delivery, label: ServiceType.Delivery},
          {value: ServiceType.Operation, label: ServiceType.Operation}
        ];

        // Methods
        $scope.onAgentChange = (agentId: string) => {
          $scope.selectedAgentId = agentId;
        };

        $scope.onPriorityChange = (priority) => {
          $scope.priority = priority;
        }

        $scope.cancel = self.$mdDialog.cancel;


        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const agentData = {
                accountId: accountId,
                agentId: $scope.selectedAgentId,
                priority: $scope.priority,
                serviceType: $scope.serviceType || ServiceType.Delivery
              };

              self.$mdDialog.hide(agentData);
            }
          }
        };
      }
    });
  }

  showRemoveAgentConfirmDialog(event: Event, agent: any) {
    // const agentName = (agent.agentReference && agent.agentReference.fullName) || agent.agentName || `Agent ${agent.agentId}`;

    const agentName = this.$filter('userName')(agent);
    const body = this.$filter('translate')('REMOVE_PREFERRED_AGENT', {agentName: agentName});

    return this.confirmDialogService.confirm(
      'Remove Agent from Ranking',
      body,
      event
    );
  }

  /**
   * Opens the Edit Agent dialog
   */
  showEditAgentDialog(event: Event, agent: any, isRestricted?: boolean) {
    const self = this;
    return this.$mdDialog.show({
      templateUrl: 'app/modules/account/views/dialogs/edit-agent-dialog.html',
      parent: angular.element(document.querySelector('#popupContainer')),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: false,
      controller: function ($scope) {
        $scope.isRestricted = isRestricted;
        $scope.agent = agent;
        $scope.priority = agent.priority;
        $scope.serviceType = agent.serviceType || ServiceType.Delivery;
        $scope.errorMessage = '';
        $scope.isSubmitting = false;
        $scope.serviceTypeOptions = [
          {value: ServiceType.Delivery, label: ServiceType.Delivery},
          {value: ServiceType.Operation, label: ServiceType.Operation}
        ];

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onPriorityChange = (priority) => {
          $scope.priority = priority;
        }

        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const updatedAgent = {
                ...agent,
                priority: $scope.priority,
                serviceType: $scope.serviceType || ServiceType.Delivery
              };

              self.$mdDialog.hide(updatedAgent);
            }
          }


        };
      }
    });
  }

  /**
   * Shows confirmation dialog for batch deletion of agents
   */
  showBatchDeleteConfirmDialog(event: Event, count: number, type: 'PREFERRED' | 'RESTRICTED' | 'DEDICATED') {
    const message = `REMOVE_${type}_AGENT_BULK`
    const body = this.$filter('translate')(message, {count: count});

    return this.confirmDialogService.confirm(
      'Delete Selected Agents',
      body,
      event
    );
  }
}

angular
  .module('bringoz.admin.accounts')
  .service('agentRankingDialogService', AgentRankingDialogService);

